<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <StatsProgressLinear></StatsProgressLinear>
      </v-col>
      <v-col cols="12">
        <AreasProgressLinear></AreasProgressLinear>
      </v-col>
      <v-col cols="12">
        <QuestsProgressLinear></QuestsProgressLinear>
      </v-col>
      <v-col cols="12">
        <BossesProgressLinear></BossesProgressLinear>
      </v-col>
      <v-col cols="12">
        <SecretsProgressLinear></SecretsProgressLinear>
      </v-col>
      <v-col cols="12">
        <TomesProgressLinear></TomesProgressLinear>
      </v-col>
      <v-col cols="12">
        <AchievementsProgressLinear></AchievementsProgressLinear>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AreasProgressLinear from "@/components/AreasProgressLinear"
import QuestsProgressLinear from "@/components/QuestsProgressLinear"
import BossesProgressLinear from "@/components/BossesProgressLinear"
import SecretsProgressLinear from "@/components/SecretsProgressLinear"
import TomesProgressLinear from "@/components/TomesProgressLinear"
import AchievementsProgressLinear from "@/components/AchievementsProgressLinear"
import StatsProgressLinear from "@/components/StatsProgressLinear"

export default {
  name: "Stats",
  components: {
    AreasProgressLinear,
    QuestsProgressLinear,
    BossesProgressLinear,
    SecretsProgressLinear,
    TomesProgressLinear,
    AchievementsProgressLinear,
    StatsProgressLinear,
  },
};
</script>